// extracted by mini-css-extract-plugin
module.exports = {"container":"PolicyLastUpdated_container__HHTzk","text":"PolicyLastUpdated_text__uzjTc"};